import Accordion from './accordion.js';
import Nav from './nav.js';
import Modal from './modal.js';
import Parallax from './parallax.js';
import Slider from './slider.js';
import anchorLink from './anchorlink.js';
import Header from './header.js';
import PCHeader from './pc-header.js';
import typeSwitcher from './type-switcher.js';
import Calculator from './calculator.js';
import Ingredient from './ingredient.js';
import swipeHint from './swipeHint.js';
import youtubePlayer from './youtubePlayer.js';
import ProgressBar from './progressbar.js';
import BrowserBack from './browserback.js';

export default class Common {
  constructor(smoothScroll) {
    this.smoothScroll = smoothScroll;
    this.init();
  }

  init() {
    this.browserBack = new BrowserBack(this.smoothScroll.lenis);
    this.accordion = new Accordion({}, this.smoothScroll.lenis);
    this.nav = new Nav();
    window.addEventListener('load', () => {
      const modal = new Modal(this.smoothScroll.lenis);
    });
    this.parallax = new Parallax();
    this.slider = new Slider();
    this.anchorLink = new anchorLink();
    this.Header = new Header(this.smoothScroll.lenis);
    this.PCHeader = new PCHeader();
    this.youtubePlayer = new youtubePlayer();
    document.querySelectorAll('.js-type-switcher').forEach(root =>
      new typeSwitcher(root, this.youtubePlayer)
    );
    document.querySelectorAll('.o-calculator').forEach(el =>
       new Calculator(el, this.smoothScroll.lenis)
    );
    this.Ingredient = new Ingredient(this.smoothScroll.lenis, window.productData);
    this.swipeHint = new swipeHint();
    this.progressBar = new ProgressBar();
  }
}